/* @flow */

import * as React from 'react';
import styled from 'styled-components';

const Button = styled.input`
  height: 30px;
  flex: 1;
  background: ${({ theme }) => theme.buttonbg || 'white'};
  border: 1px solid ${({ theme }) => theme.inputBorder || '#ccc'};
  border-color: ${({ theme, selected }) => (selected ? theme.activeBorder : '')};
  color: ${({ theme, selected }) => selected ? theme.activeBorder : ''};
  cursor: pointer;
  outline: none;
  margin: ${({ margin }) => margin || '0  4px auto auto'};
  & :hover {
      border-color: ${({ theme }) => theme.activeBorder};
      color: ${({ theme }) => theme.activeBorder};
    }

  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;
  }
`;

export type Props = {
  value: string | number,
  onClick: Function,
  percentBtn: string,
  selected: boolean,
  text: string,
};

export default
class ModeButton extends React.Component<Props> {
  _handleClick = () => {
    const val = this.props.value;
    this.props.onClick(val);
  }

  render() {
    const {
      percentBtn, selected, text,
    } = this.props;
    return (
      <Button id={percentBtn} type="button" value={text} onClick={this._handleClick} selected={selected} />
    );
  }
}
